import { REGISTER_PM_TRACKING_FAILURE } from '.';

export function registerPmTrackingFailure(error: unknown) {
  return { error, type: REGISTER_PM_TRACKING_FAILURE };
}
